export default {
    APPLICATION_PATH: {
        ROOT: '/',
        COMPLETED: '/success',
    },
};
